import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "country",
  "use": "country-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"country\"><path d=\"M20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11S26.075 9 20 9zm0 2a9 9 0 110 18 9 9 0 010-18z\" /><path d=\"M20 9c-2.957 0-4.927 4.791-4.998 10.672L15 20c0 6.03 1.988 11 5 11s5-4.97 5-11-1.988-11-5-11zm0 2c1.406 0 3 3.984 3 9s-1.594 9-3 9-3-3.984-3-9 1.594-9 3-9z\" /><path d=\"M30 19v2H10v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol